import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { setNavigate } from '../../lib/navigation.js';

// Conecta el navigate real de react-router con lib/navigation.ts, para que
// lib/api.ts pueda redirigir a /sin-acceso al interceptar un 403 sin
// depender de window.location (ver App.tsx, montado dentro del Router).
export function NavigationBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
}
